<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title" v-encode="pageTitle"></h1>
          </div>
        </div>
      </div>
      <div class="m-content m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div v-if="configuration.visitrecorder.enabled">
              <div class="row" v-if="status === 0">
                <div class="col-sm-12">
                  <div class="intro mb-5" v-html="configuration.visitrecorder.welcome"></div>
                  <qr-code-scanner
                    v-bind:qrbox="250"
                    v-bind:fps="10"
                    @scan="onScan">
                  </qr-code-scanner>
                  <p><input v-model="code" type="text" id="code" name="code" placeholder="Kod" class="code-input" /></p>
                  <p><button @click="onSubmit" class="btn btn-ls code-submit">Dodaj kod</button></p>
                </div>
              </div>
              <div class="row" v-if="status === 1">
                <div class="col-sm-12 text-center mb-4">
                  <h3>Oczekiwanie na potwierdzenie kodu {{ code }}</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro">
                    Poinformuj sprzedawcę o zeskanowaniu kodu. Po zatwierdzeniu wizyty przez sprzedawcę do Twojego konta
                    zostaną dodane punkty.
                  </div>
                  <div class="text-center mt-5">
                    <spinner></spinner>
                  </div>
                </div>
              </div>
              <div class="row" v-if="status === 2">
                <div class="col-sm-12 text-center mb-4">
                  <h3>Dziękujemy za wizytę!</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro" v-html="configuration.visitrecorder.thankyou"></div>
                  <div class="text-center mt-5">
                    <span class="points">+ {{ configuration.visitrecorder.points }} {{ pointsSymbol }}</span>
                  </div>
                  <div class="col-sm-12 mt-5">
                    <button @click="onReset" class="btn btn-ls code-submit">Skanuj nowy kod</button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="status === 3">
                <div class="col-sm-12 text-center mb-4">
                  <h3>Wizyta została odrzucona!</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro">
                    Niestety Twoja wizyta została odrzucona przez sprzedawcę.
                  </div>
                </div>
                <div class="col-sm-12 mt-5">
                  <button @click="onReset" class="btn btn-ls code-submit">Skanuj nowy kod</button>
                </div>
              </div>
            </div>
            <div class="row" v-if="!configuration.visitrecorder.enabled">
              <div class="col-sm-12 text-center">
                <p>Rejestracja wizyt została wyłączona</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Encode from "@/directives/encode";
import Page from "./Page";
import QrCodeScanner from "../qrcode/QrCode"
import PageTitle from "@/mixins/pageTitle";
import Spinner from "@/components/spinner/Spinner";
import {mapActions, mapState} from "vuex";
import axios from 'axios';

export default {
  name: "VisitrecorderPage",
  data: function () {
    return {
      code: '',
      status: 0,
      checkLoop: null
    };
  },
  components: {QrCodeScanner, Page, Spinner},
  directives: {Encode},
  mixins: [PageTitle('Zeskanuj kod')],
  created() {
    this.fetchVisitrecorder()
      .catch((error) => {
        if (418 === error.response.status) {
          console.info('[VR] Visit registration disabled');
          this.configuration.visitrecorder.enabled = false;
        }
      });
  },
  beforeMount() {
    if (!this.isAuthorized) {
      this.logout();
    }
  },
  beforeDestroy() {
    this.clearCheck();
  },
  methods: {
    ...mapActions(['logout', 'fetchVisitrecorder']),
    onScan(decodedText, decodedResult) {
      this.code = decodedText;
      this.onSubmit(decodedText);
    },
    onReset() {
      this.status = 0;
    },
    onSubmit() {
      axios.post('/visitrecorder', {code: this.code})
        .then((res) => {
          console.log('[VR] Code used', this.code);
          this.status = 1;
          this.onCheck(this.code);
        })
        .catch((error) => {
          if (418 === error.response.status) {
            console.info('[VR] Visit registration disabled');
            this.configuration.visitrecorder.enabled = false;
          }
        })
    },
    onCheck(code) {
      let $this = this;
      let loopCount = 0;
      this.checkLoop = setInterval(function () {
        axios.get('/visitrecorder/check/' + code)
          .then((res) => {
            console.log('[VR] Code check', code, res.data);

            if ('confirmed' === res.data.state) {
              $this.status = 2;
            } else if ('rejected' === res.data.state) {
              $this.status = 3;
            }

            loopCount++;

            if (loopCount >= 60) {
              clearInterval($this.checkLoop);
            }
          })
          .catch((error) => {
            if (418 === error.response.status) {
              console.info('[VR] Visit registration disabled');
              this.configuration.visitrecorder.enabled = false;
            }
          });
      }, 5000);
    },
    clearCheck() {
      if (null !== this.checkLoop) {
        clearInterval(this.checkLoop);
        this.checkLoop = null;
      }
    }
  },
  computed: mapState({
    isAuthorized: state => state.auth.isAuthorized,
    configuration: state => state.visitrecorder,
    pointsConfig: state => state.settings.points,
    pointsSymbol() {
      return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
    },
  }),
  watch: {
    status: function(value) {
      console.log('[VR] Status changed', value);

      if (1 !== value) {
        this.clearCheck();
      }

      if (0 === value) {
        this.code = '';
      }
    }
  },
}
</script>

<style>
.intro {
  text-align: center;
}
.code-input {
  width: 100%;
  border: 2px solid gray;
  margin-top: 1rem;
  padding: 12px 6px;
  border-radius: 12px;
  text-align: center;
  text-transform: uppercase;
}
.code-input:focus {
  outline: none;
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.code-submit{
  width: 100%;
  border-radius: 12px !important;
  padding: 12px 6px;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
}
.points {
  background-color: var(--accent-color) !important;
  padding: 1.2rem;
  color: #fff;
  font-weight: 500;
  font-size: 2rem;
  text-align: center;
  border-radius: 30px;
}
</style>